<template>
    <div>

      <!-- Modal -->
      <div class="modal fade in" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="false" style="display: block;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="close()">&times;</button>
              <h4 class="modal-title" id="myModalLabel">Let's Do This</h4>
            </div>
            <div class="modal-body" style="max-height: 800px; overflow: scroll;">

<!--              <span class="row" style="position: relative; top: 25px; cursor: pointer;"-->
<!--                    v-if="CloudProvider"-->
<!--                    v-on:click="back()"-->
<!--              >-->
<!--                <i class="fa fa-arrow-circle-left"></i> back-->
<!--              </span>-->


              <div class="row">

                <div class="col-xs-12">

<!--                  <div v-if="!CloudProvider && !AwsRegion" class="row">-->


<!--                    <h2>Select your Cloud Provider</h2>-->
<!--                    <p>Deploy Skippr to your private cloud, your data never leaves your network.</p>-->

<!--                    <div v-for="(vendor, index) in cloud_vendors" :key="index"-->
<!--                      class="col-xs-12 col-sm-3"-->
<!--                      v-on:click="selectCloudProvider(vendor)"-->
<!--                      style="cursor: pointer;'"-->
<!--                    >-->

<!--                      <div class="panel panel-default jumbotron">-->
<!--                        <div class="panel-body text-center">-->
<!--                          <img width="90px" :src="'images/logos/' + vendor.icon + '.png'"/><br />-->
<!--                          <span v-if="commingSoon != vendor.name">{{ vendor.name }}</span>-->
<!--                          <span v-if="commingSoon == vendor.name" class="label label-default">Coming Soon</span>-->
<!--                        </div>-->
<!--                      </div>-->

<!--                    </div>-->

<!--                  </div>-->



<!--                  <div v-if="CloudProvider && !AwsRegion">-->

<!--                    <h2>Which AWS region would you like to deploy Skippr to?</h2>-->
                    <!--                    <p>Skippr deploys to your private cloud, your data never leaves your network.</p>-->

                    <div  v-for="(region, index) in aws_regions"
                          :key="index"
                          :class="{'row': index % 4 == 4}">



                      <div class="col-xs-12 col-sm-3"
                           v-on:click="selectAwsRegion(region)"
                           style="cursor: pointer;'"
                      >
                        <div class="panel panel-default jumbotron">
                          <div class="panel-body text-center">
                            <strong>{{ region.name }}</strong><br />
                            {{ region.location }}
                          </div>
                        </div>
                      </div>

                    </div>

<!--                  </div>-->


<!--                  v-if="AwsRegion"-->
<!--                  v-if="CloudProvider"-->
                  <signup
                    :aws-region="AwsRegion"
                  ></signup>

                </div>

              </div>

            </div>
<!--            <div class="modal-footer">-->
<!--              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>-->
<!--              <button type="button" class="btn btn-primary">Save changes</button>-->
<!--            </div>-->
          </div>
        </div>
      </div>

    </div>
</template>

<script>

  import Signup from '../../Signup.vue'

    export default {
        name: 'DeploySkippr',
        components: {
          Signup,
        },
        head: {
          title: {
            inner: 'Deploy Skippr',
            separator: '-',
            complement: 'Perfect data in minutes not months'
          },
          meta: [
            {
              name: 'description',
              content: 'Deploy Skippr to your private cloud, your data never leaves your network'
            }
          ]
        },
        props: {
            msg: String
        },
        data() {
          return {
            CloudProvider: '',
            AwsRegion: '',
            commingSoon: '',
            cloud_vendors: [
              { name: 'My Machine', icon: 'nerd', enabled: true },
              { name: 'AWS', icon: 'aws', enabled: true },
              { name: 'Azure', icon: 'azure', enabled: true },
              { name: 'Google', icon: 'gpc', enabled: true },
            ],
            aws_regions: [
            //   { name: 'US East', location: 'Ohio', code: 'us-east-2', enabled: true },
            //   { name: 'US East', location: 'N. Virginia', code: 'us-east-1', enabled: true },
            //   { name: 'US West', location: 'N. California', code: 'us-west-1', enabled: true },
            //   { name: 'US West', location: 'Oregon', code: 'us-west-2', enabled: true },
            //   { name: 'Africa', location: 'Cape Town', code: 'af-south-1', enabled: true },
            //   { name: 'Asia Pacific', location: 'Hong Kong', code: 'ap-east-1', enabled: true },
            //   { name: 'Asia Pacific', location: 'Mumbai', code: 'ap-south-1', enabled: true },
            //   { name: 'Asia Pacific', location: 'Seoul', code: 'ap-northeast-2', enabled: true },
            //   { name: 'Asia Pacific', location: 'Singapore', code: 'ap-southeast-1', enabled: true },
            //   { name: 'Asia Pacific', location: 'Sydney', code: 'ap-southeast-2', enabled: true },
            //   { name: 'Asia Pacific', location: 'Tokyo', code: 'ap-northeast-1', enabled: true },
            //   { name: 'Canada', location: 'Central', code: 'ca-central-1', enabled: true },
            //   { name: 'Europe', location: 'Frankfurt', code: 'eu-central-1', enabled: true },
            //   { name: 'Europe', location: 'Ireland', code: 'eu-west-1', enabled: true },
            //   { name: 'Europe', location: 'London', code: 'eu-west-2', enabled: true },
            //   { name: 'Europe', location: 'Milan', code: 'eu-south-1', enabled: true },
            //   { name: 'Europe', location: 'Paris', code: 'eu-west-3', enabled: true },
            //   { name: 'Europe', location: 'Stockholm', code: 'eu-north-1', enabled: true },
            //   { name: 'Middle East', location: 'Bahrain', code: 'me-south-1', enabled: true },
            //   { name: 'South America', location: 'São Paulo', code: 'sa-east-1', enabled: true },
            ],
          }
        },
        created() {
          console.log('Deploy Wizard Created')
          this.$gtag.event('deploy_wizard', {
            event_category: 'deploy-wizard',
            event_label: 'deploy-wizard-start'
          });
        },
        methods: {
          close() {
            window.location = '/'

          },
          clickEvent(name) {
            this.$gtag.event('click', {
              event_category: 'deploy-wizard',
              event_label: name,
            })
          },
          selectCloudProvider(vendor) {

            this.clickEvent(vendor.name)

            if (vendor.enabled) {
              this.CloudProvider = vendor.name

              this.$gtag.event('deploy_wizard', {
                event_category: 'deploy-wizard',
                event_label: 'deploy-wizard-page-2'
              });

              // if vendor anything other than 'AWS' then default AwsRegion to 'N/A'

              // if (vendor.name != 'AWS') {
              //   this.AwsRegion = ''
              // }

            } else {
              this.commingSoon = vendor.name
            }

          },
          selectAwsRegion(region) {

            this.clickEvent(region.location)

            if (region.enabled) {
              this.AwsRegion = region.code
            }

          },
          back() {

            this.clickEvent('back-button')

            if (this.AwsRegion) {
              this.AwsRegion = ''
            } else if (this.CloudProvider) {
              this.CloudProvider = ''
            }
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .modal-dialog {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  .modal-content {
    height: 100%;
    border-radius: 0;
  }

</style>
